import { EXTERNAL_API_CALLS_FILTERS_FAILURE, EXTERNAL_API_CALLS_FILTERS_REQUEST, EXTERNAL_API_CALLS_FILTERS_SUCCESS, GetExternalCallsFiltersActionTypes, GetExternalCallsFiltersState } from './types';

const defaultState: GetExternalCallsFiltersState = {
  isLoading: false,
  errorMessage: '',
};

function externalCallsFilters(state = defaultState, action: GetExternalCallsFiltersActionTypes): GetExternalCallsFiltersState {
  switch (action.type) {
    case EXTERNAL_API_CALLS_FILTERS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case EXTERNAL_API_CALLS_FILTERS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: '',
      };
    case EXTERNAL_API_CALLS_FILTERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: '',
      };
    default:
      return state;
  }
}

export default externalCallsFilters;
